import React from 'react'
import { Loading, ProgressBar, Table, TBody, TD, TH, THead, TR } from '@sede-enterprise/shell-ds-react-framework';
import usePageData from './hooks/usePageData';


import * as R from "rambda";

const PageData = ({ selectedSite, startDate, endDate }) => {

    const { userPageData, loading } = usePageData(selectedSite, startDate, endDate);
    const cells = [
        {
            id: "page",
            align: "left",
            label: "Page",
            content: (row) =>
                R.path(
                    ["page"],
                    row
                ),
        },
        {
            id: "assets",
            align: "right",
            label: "Assets",
            content: (row) =>
                R.path(["asset"], row),
        },
        {
            id: "user",
            align: "right",
            label: "Users",
            info: "no. of users viewed the page",
            content: (row) =>
                R.path(["user"], row),
        },
        {
            id: "views",
            align: "right",
            label: "Views",
            info: 'total views to page by (Users)',
            content: (row) =>
                R.path(["views"], row),
        },
        {
            id: "views%",
            align: "left",
            label: "Views % ",
            info: '(Views/sum of views of all page)*100',
            content: (row) =>
                <ProgressBar value={R.path(["viewsPrecentage"], row)} label type='line' size='small' />
        },
    ];

    return loading ? <div className='loading-container' role='status'><Loading /></div> : userPageData?.length > 0 ?
        <div className='page-data-container'>
            <Table className='basic-table' style={{ width: "100%" }}>
                <THead style={{ background: "rgb(245, 245, 245)" }}>
                    <TR>
                        <TH>Page</TH>
                        <TH>Assets</TH>
                        <TH>Users</TH>
                        <TH>Views</TH>
                        <TH>Views %</TH>
                    </TR>
                </THead>
                <TBody>
                    {userPageData?.map((row) =>
                        <TR key={row.id}>
                            {cells.map(cell => (<TD component="th" scope="row" key={cell.id}>
                                {cell.content(row)}
                            </TD>
                            ))}
                        </TR>
                    )}
                </TBody>
            </Table>
        </div>
        : <p className='data-value'>No Data Available</p>

}

export default PageData